import './styles.scss';
import createElement from '../../utils/createElement';


export default class RootContainer {

    constructor(screens) {
        this.html = {};
        this.html.root = null;

        this.screenNames = [
            'russia',
            'philippines',
            'iceland',
            'japan',
            'algeria'
        ];

        this.ic = 'root_invisible';

        this.progress = this.progress.bind(this);
        this.loadStarted = this.loadStarted.bind(this);
        this.loadFinished = this.loadFinished.bind(this);
        this.updateParams = this.updateParams.bind(this);
        this._callAction = this._callAction.bind(this);
        this._screenNext  = this._screenNext.bind(this);
        this._screenBefore = this._screenBefore.bind(this);

        this.screens = screens.map(Screen => {
            return new Screen(
                {
                    progress: this.progress,
                    loadStarted: this.loadStarted,
                    loadFinished: this.loadFinished
                },
                this.updateParams
            );
        });
        this.screens.forEach(s => {
            if (s.preload) {
                s.preload();
            }
        });

        this.focusedScreenIndex = null;

        this.currentWindowWidth = null;
        this.currentWindowHeight = null;

        this.PARALLAX_COEFFICIENT_PERCENT = 0.005;
        this.canParallax = true;

        this.PROGRESS_COEFFICIENT = 4.55;

        this.sliderFixFlag = false;

        this.sliderCanSlide = true;

        this.globalScreenState = false;

        this.SHARE_TITLE = 'Путешествуй с Samsung';
        this.SHARE_DESC = 'Безграничное путешествие по миру на специальном проекте Hi-Tech Mail.ru';

        this.travel = this.travel.bind(this);
    }

    render(rootId) {
        this.html.root = document.getElementById(rootId);

        this.html.btnLeft = <div class="root__btn root__btn_left root_top"/>;
        this.html.btnRight = <div class="root__btn root__btn_right root_top"/>;
        this.html.enterScreenBtn = <div class="root__enter-btn root_top" />;
        this.html.btnTravel = <div class="root__btn root__btn_travel root_top">Путешествовать</div>;
        this.html.btnMenu = <div class="root__btn root__btn_menu root_top">
            <div class="root__btn root__btn_menu_inside root_top"/>
        </div>;
        this.html.btnMenu.style.display = 'none';
        this.html.screensContainer = <div class="root__screens-container"/>;
        this.html.mobile = <div class="root__mobile root_top"/>;

        this.html.loaderWrapper = <div class="root__loader-wrapper root__loader-wrapper_invisible root_top">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 157 157" width="100%" height="100%" version="1.1">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Artboard" transform="translate(-22.000000, -22.000000)" stroke="#FFFFFF" stroke-width="8">
                        <g id="preloader" transform="translate(28.000000, 28.000000)">
                            <circle id="Oval" stroke-opacity="0.15" cx="72.5" cy="72.5" r="72.5"/>
                            { this.html.loader = <circle class="transition-circle" id="Oval" stroke-linecap="round" stroke-dasharray="1,1000" transform="scale(-1, -1) translate(-72.5, -72.5) rotate(-270.000000)" cx="0" cy="0" r="72.5"/> }
                        </g>
                    </g>
                </g>
            </svg>
            { this.html.loaderValue = <div class="root__loader-value"/> }
        </div>;

        this.html.loader.style.strokeDasharray = '1000';
        this.html.loader.style.strokeDashoffset = '1000';

        this.html.root.appendChild(<div class="root__container">
            { this.html.loaderWrapper }
            { this.html.mobile }
            { this.html.btnLeft }
            { this.html.enterScreenBtn }
            { this.html.btnRight }
            { this.html.btnTravel }
            { this.html.btnMenu }
            { this.html.screensContainer }
            <a target="blank" href="http://r.mail.ru/n258455369" class="root__logo root__logo_left root_top"/>
            <a target="blank" href="http://r.mail.ru/n258455369"  class="root__logo root__logo_right root_top"/>
            { this.html.btnShare = <div class="root__share root_highest"/> }
            { this.html.shareFacebook = <div class="root__share root__share-facebook root_top "/> }
            { this.html.shareOk = <div class="root__share root__share-ok root_top "/> }
            { this.html.shareVk = <div class="root__share root__share-vk root_top "/> }
            <div class="root__sound root__sound_unmute root_top"/>
        </div>);

        this.screens.forEach(screen => {
           screen.render(this.html.screensContainer);
        });

        this._updateScreensSizes();

        this._initListeners();

        this.checkLocation();
    }

    checkLocation(){

        const screenName = window.location.hash.slice(1);

        let screenIndex = this.screenNames.indexOf(screenName);
        screenIndex = screenIndex === -1 ? 0 : screenIndex;

        this._focusScreen(screenIndex);
    }

    updateLocation(){
        const locationName = this.screenNames[this.focusedScreenIndex];
        if (window.history.replaceState){
            window.history.replaceState(locationName, locationName, '/#' + locationName);
        }
        window.parent.postMessage(JSON.stringify({
            'method': 'setHash',
            'data': locationName
        }), '*');
    }

    progress(percentage) {
        if (percentage > 95){
            this.html.loader.style.transition = 'none';
        }else{
            this.html.loader.style.transition = null;
        }
        this.html.loader.style.strokeDashoffset = `${ 1000 - percentage * this.PROGRESS_COEFFICIENT}`;
        this.html.loaderValue.innerText = `${Math.round(percentage)}%`;
    }

    loadStarted(percent = 0) {
        // console.log('started ', percent);
        this.html.loader.style.transition = null;
        this.html.loader.style.strokeDashoffset = '1000';
        this.html.loaderValue.innerText = `${Math.round(percent)}%`;
        this.html.loaderWrapper.classList.remove('root__loader-wrapper_invisible');
    }

    loadFinished() {
        this.html.loader.style.transition = 'none';
        this.html.loader.style.strokeDashoffset = '545';
        this.html.loaderWrapper.classList.add('root__loader-wrapper_invisible');
        //setTimeout(() => {
            this.html.loader.style.strokeDashoffset = '1000';
            this.html.loaderValue.innerText = `0%`;
        //}, 500);
    }

    updateParams(isFocused, isEntered, isLoaded){
        const screenState = isEntered ? isLoaded ? 'active' : 'loading' : 'inactive';
        if (screenState !== 'active' && screenState !== 'loading'){
            this.canParallax = true;
        }else{
            this.canParallax = false;
            this.html.mobile.style.transform = '';
        }
        this._callAction(screenState);
    }

    _updateScreensSizes() {
        this.currentWindowHeight = window.innerHeight;
        this.currentWindowWidth = window.innerWidth;
        this.html.screensContainer.style.width = this.screens.length * this.currentWindowWidth + 'px';
        this.html.screensContainer.style.height = this.currentWindowHeight + 'px';
        this._updateScreensShift(false);
        this.screens.forEach(screen => {
            screen.size(
                this.currentWindowHeight,
                this.currentWindowWidth
            );
        });

        if (this.sliderFixFlag){
            this.html.screensContainer.style.paddingLeft = `${this.currentWindowWidth}px`;
        }
    }

    travel() {

        // console.log('enter 3');
        // if (window.ga) {
        //     ga('s8.send', 'event', `screen${this.focusedScreenIndex + 1}`, 'enter', {
        //         nonInteraction: true
        //     });
        // }
        if (!this.globalScreenState) {
            if (window.ga) {
                ga('s8.send', 'event', `screen${this.focusedScreenIndex + 1}`, 'enter', {
                    nonInteraction: true
                });
            }
            // console.log('enter 3');
            this.screens[this.focusedScreenIndex].clickEnter();
            this.screens.forEach((screen, index) => {
                if (index !== this.focusedScreenIndex && screen.isLoaded){
                    screen.clickEnter();
                }
            });
            this.globalScreenState = true;
        }
    };

    _initListeners() {

        const self = this;

        const {
            btnLeft,
            btnRight,
            btnTravel,
            btnMenu,
            btnShare,
            shareFacebook,
            shareOk,
            shareVk,
            enterScreenBtn
        } = this.html;

        // clicks
        const onClick = (e, f) => {
            e.addEventListener('click', f);
        };

        onClick(btnLeft, () => {
            this._screenBefore();
        });

        onClick(btnRight, () => {
            this._screenNext();
        });

        onClick(btnTravel, this.travel);
        onClick(enterScreenBtn, this.travel);

        onClick(btnMenu, () => {
            // this.screens[this.focusedScreenIndex].clickExit();
            if (this.globalScreenState) {
                this.globalScreenState = false;
                this.screens.forEach(screen => {
                    screen.clickExit();
                })
            }
        });

        onClick(btnShare, e => {
            btnShare.classList.toggle('root__share_active');
            shareFacebook.classList.toggle('root__share-facebook_active');
            shareOk.classList.toggle('root__share-ok_active');
            shareVk.classList.toggle('root__share-vk_active');
        });

        //sharing
        onClick(shareFacebook, () => {
            if(shareFacebook.classList.contains('root__share-facebook_active')){
                window.parent.postMessage(JSON.stringify({
                    'method': 'getLocation',
                    'data': 'sharingFacebook'
                }), '*');
            }
        });

        onClick(shareOk, () => {
            if(shareOk.classList.contains('root__share-ok_active')){
                window.parent.postMessage(JSON.stringify({
                    'method': 'getLocation',
                    'data': 'sharingOk'
                }), '*');
            }
        });

        onClick(shareVk, () => {
            if(shareVk.classList.contains('root__share-vk_active')){
                window.parent.postMessage(JSON.stringify({
                    'method': 'getLocation',
                    'data': 'sharingVk'
                }), '*');
            }
        });

        // transitions
        const tansitionsElems = [
            btnLeft,
            btnRight,
            btnTravel,
            btnMenu
        ];

        tansitionsElems.forEach(elem => elem.addEventListener('transitionend', e => {
            if (elem.classList.contains(self.ic)){
                // console.warn('display none');
                // console.warn(elem);
                elem.style.display = 'none';
            }
        }));

        //resize
        window.addEventListener('resize', this._updateScreensSizes.bind(this) );

        // parallax
        window.addEventListener("mousemove", e => {
            if (self.canParallax){
                const shiftX = (e.x - self.currentWindowWidth/2) * self.PARALLAX_COEFFICIENT_PERCENT;
                //const shiftY = (e.y - self.currentWindowHeight/2) * self.PARALLAX_COEFFICIENT_PERCENT;
                self.html.mobile.style.transform = `translateX(${shiftX}px)`;//, ${shiftY}px)`;
            }
        });

        //keys
        const canNavigateByArrows = () => {
            //if (this.focusedScreenIndex === 0){
            //    if (this.screens[this.focusedScreenIndex].isEnteredNow()){
            //        return false;
            //    }
            //}
            return true;
        };

        document.addEventListener("keydown", e => {
            if(e.keyCode == 39 && canNavigateByArrows()){
                this._screenNext();
            }

            if(e.keyCode == 37 && canNavigateByArrows()){
                this._screenBefore();
            }
        });


        //sharing

        const getImageUrl = () => 'http://samsung-promo-s8.ktsstudio.ru/static/img/share_images/' + self.screenNames[self.focusedScreenIndex] + '.jpg';
        // const getImageUrl = () => 'https://uploads.scratch.mit.edu/users/avatars/1385/1878.png';

        const clickShareVk = (url) => {
            const shareUrl = 'https://vk.com/share.php?url=' + url + '&title=' + this.SHARE_TITLE + '&description=' +
                    this.SHARE_DESC + '&image=' + getImageUrl() + '&noparse=true';
            window.open(shareUrl, 'Share this', 'width=640,height=480,location=no,toolbar=no,menubar=no');
            ga('s8.send', 'event', 'share', 'vk');
        };

        const clickShareFacebook = (url) => {
            const shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url + '&picture=' + getImageUrl() + '&title=' + this.SHARE_TITLE + '&description=' + this.SHARE_DESC;
            window.open(shareUrl,'sharer','toolbar=0,status=0,width=700,height=400');
            ga('s8.send', 'event', 'share', 'fb');
        };

        const clickShareOk = (url) => {
            const shareUrl = 'https://connect.ok.ru/offer?url=' + url + '&title=' + this.SHARE_TITLE + '&description=' + this.SHARE_DESC + '&imageUrl=' + getImageUrl();
            window.open(shareUrl,'sharer','toolbar=0,status=0,width=700,height=400');
            ga('s8.send', 'event', 'share', 'ok');
        };

        //messages from  parent window
        window.addEventListener('message', e => {
            if (e.data){
                const parsedData = JSON.parse(e.data);
                const urlToShare = parsedData.data.replace(/#/g, "%23");
                switch (parsedData.actionName){
                    case 'sharingFacebook':
                        clickShareFacebook(urlToShare);
                        // clickShareFacebook('http://samsung-promo-s8.ktsstudio.ru/');
                        break;

                    case 'sharingVk':
                        clickShareVk(urlToShare);
                        // clickShareVk('http://samsung-promo-s8.ktsstudio.ru/');
                        break;

                    case 'sharingOk':
                        clickShareOk(urlToShare);
                        // clickShareOk('http://samsung-promo-s8.ktsstudio.ru/');
                        break;
                }

            }
        });
    }

    _focusScreen(index) {

        // console.log('focus SCREEN');

        if (this.focusedScreenIndex !== null){
            this.screens[this.focusedScreenIndex].unFocus();
        }

        const maxIndex = this.screens.length - 1;

        const locationName = this.screenNames[index];

        if (window.ga) {
            ga('s8.send', 'pageview', locationName);
        }

        if (window.ga) {
            ga('s8.send', 'event', `screen${index + 1}`, 'focus', {
                nonInteraction: true
            });
        }

        if (this.enterTimeout) {
            clearTimeout(this.enterTimeout);
        }

        this.enterTimeout = setTimeout(this.travel, 3000);

        // to back
        if (index === maxIndex && this.focusedScreenIndex === 0){
            this.sliderCanSlide = false;
            this.screens[maxIndex].float('left');
            this._updateScreensShift(true, -1);
            this.focusedScreenIndex = index;
            const focusedScreen = this.screens[this.focusedScreenIndex];
            focusedScreen.focus();
            if (this.globalScreenState){
                // console.log('enter 0');
                if (window.ga) {
                    ga('s8.send', 'event', `screen${index + 1}`, 'enter');
                }
                if(!focusedScreen.isEntered){
                    focusedScreen.clickEnter();
                }
            }else{
                if (focusedScreen.isEntered){
                    focusedScreen.clickExit();
                }
            }
            this.updateLocation();
            setTimeout(() => {
                this.screens[maxIndex].float();
                this._updateScreensShift(false);
                this.sliderCanSlide = true;
            }, 500);
            return;
        }

        // to start
        if (index === 0 && this.focusedScreenIndex === maxIndex){
            this.sliderCanSlide = false;
            this.sliderFixFlag = true;
            this.screens[0].float('right');
            this.html.screensContainer.style.paddingLeft = `${this.currentWindowWidth}px`;
            this._updateScreensShift(true, maxIndex + 1);
            this.focusedScreenIndex = index;
            const focusedScreen = this.screens[this.focusedScreenIndex];
            focusedScreen.focus();
            if (this.globalScreenState){
                // console.log('enter 1');
                if (window.ga) {
                    ga('s8.send', 'event', `screen${index + 1}`, 'enter');
                }
                if(!focusedScreen.isEntered){
                    focusedScreen.clickEnter();
                }
            }else{
                if (focusedScreen.isEntered){
                    focusedScreen.clickExit();
                }
            }
            this.updateLocation();
            setTimeout(() => {
                this.screens[0].float();
                this._updateScreensShift(false);
                this.html.screensContainer.style.paddingLeft = '';
                this.sliderFixFlag = false;
                this.sliderCanSlide = true;
            }, 500);
            return;
        }

        this.focusedScreenIndex = index;
        const focusedScreen = this.screens[this.focusedScreenIndex];
        focusedScreen.focus();
        if (this.globalScreenState){
            // console.log('enter 2');
            if (window.ga) {
                ga('s8.send', 'event', `screen${index + 1}`, 'enter');
            }
            if(!focusedScreen.isEntered){
                focusedScreen.clickEnter();
            }
        }else{
            if (focusedScreen.isEntered){
                focusedScreen.clickExit();
            }
        }
        this._updateScreensShift(true);
        this.updateLocation();
    }

    _updateScreensShift(animated, pseudoIndex) {
        this.html.screensContainer.style.transition = animated ? '' : 'none';
        let index = this.focusedScreenIndex;
        if (pseudoIndex !== undefined){
            index = pseudoIndex;
        }
        this.html.screensContainer.style.transform = `translateX(${(-1) * this.currentWindowWidth * index}px)`;
    }

    _callAction(action){
        const v = (name, visible) => {
            const elem = this.html['btn' + name];
            if (visible){
                elem.style.display = '';
            }
            elem.classList[visible ? 'remove' : 'add'](this.ic)
        };

        switch(action) {
            case 'active':
                v('Left', true);
                v('Right', true);
                v('Travel', false);
                v('Menu', true);
                break;

            case 'inactive':
                v('Left', true);
                v('Right', true);
                v('Travel', true);
                v('Menu', false);
                break;

            case 'loading':
                // v('Left', false);
                // v('Right', false);
                v('Left', true);
                v('Right', true);
                v('Travel', false);
                v('Menu', false);
                break;
        }
    }

    _screenNext(){
        if (!this.sliderCanSlide){
            return;
        }

        if (this.focusedScreenIndex < this.screens.length - 1){
            this._focusScreen(this.focusedScreenIndex + 1);
        }else{
            this._focusScreen(0);
        }
        return;
    }

    _screenBefore(){
        if (!this.sliderCanSlide){
            return;
        }

        if (this.focusedScreenIndex > 0){
            this._focusScreen(this.focusedScreenIndex - 1);
        }else{
            this._focusScreen(this.screens.length - 1);
        }
        return;
    }
};


// WEBPACK FOOTER //
// ./src/js/containers/Root/index.js